import * as Yup from "yup";

export const CompanySchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  email: Yup.string().email("Invalid email").required("Required"),
  formLink: Yup.string().required("Required"),
  apiUsername: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  apiPassword: Yup.string()
    .min(7, "Password must be atleast 8 characters.")
    .required("Required"),
  clientId: Yup.string().required("Required"),
});
